var map = {
	"./de.json": 86338,
	"./en.json": 20914,
	"@freshsolutions/fresh-vue-cards/src/locale/de.json": 86338,
	"@freshsolutions/fresh-vue-cards/src/locale/en.json": 20914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75855;